
      import { initApp } from "./main.js";
      initApp("#container");
    